import { ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface'
import { SubscriptionId } from 'modules/payment/subscriptions/types/subscription-interface'
import { SETTINGS_SUBSCRIPTIONS_API } from 'modules/profile/manage-subscriptions/api/update-customer-fields-api'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

interface ManageCustomerFieldsProps {
  subscriptionId: SubscriptionId
  isFetchAllowed: boolean
}

export const useManageCustomerFields = ({
  subscriptionId,
  isFetchAllowed,
}: ManageCustomerFieldsProps) => {
  const { user } = useUser()

  const { fetcher } = useFetch<RequestMethodsEnum.get, ManageFieldsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data, mutate, isLoading } = useControlledSwr(
    () => user && `${SETTINGS_SUBSCRIPTIONS_API}/${subscriptionId}/customer/field-values`,
    fetcher,
    undefined,
    isFetchAllowed,
  )

  return {
    data,
    mutate,
    isLoadingFields: isLoading,
  }
}
